export default __webpack_public_path__ + "static/media/landing-background.0d1d1eca.jpg";